import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from 'src/store';
import { getErrorMessage } from 'src/utils/utilService';
import { setSnackbarMessage } from '../snackbarMessage/snackbarSlice';
import { initialState } from './state';
import * as api from 'src/api/etc/etc';
import { ShortURL } from 'src/admin-entity/interface/etc/short-url.interface';

export const getShortURLList = createAsyncThunk(
    `etcSlice/getShortURLList`,
    async (_, { getState, dispatch, rejectWithValue }) => {
        try {
            const { page, take } = (getState() as AppState).etc;
            const res = await api.getShortURLList(take, page);
            return res.data;
        } catch (err) {
            dispatch(setSnackbarMessage(getErrorMessage(err)));
            return rejectWithValue(err);
        }
    },
);

export const deleteURL = createAsyncThunk(
    `etcSlice/deleteURL`,
    async (shortURL: ShortURL, { dispatch, rejectWithValue }) => {
        try {
            const res = await api.deleteShortURL(shortURL);
            return res.data;
        } catch (err) {
            dispatch(setSnackbarMessage(getErrorMessage(err)));
            return rejectWithValue(err);
        }
    },
);

export const etcSlice = createSlice({
    name: 'etcSlice',
    initialState,
    reducers: {
        init: () => {
            return initialState;
        },
        setPage: (state, action: PayloadAction<number>) => {
            state.page = action.payload;
        },
        setTake: (state, action: PayloadAction<number>) => {
            state.take = action.payload;
        },
    },
    extraReducers: builder => {
        builder.addCase(getShortURLList.fulfilled, (state, action) => {
            state.shortURLList = action.payload;
        });
    },
});

export default etcSlice.reducer;
export const { init, setPage, setTake } = etcSlice.actions;
